import type {
  DisplayCondition,
  MailContentProps,
  MailMetadata,
} from "../../lib/types";
import { StatutMailEnum } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function PreparationPointVisio({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        Bonjour {variablesData.responsable_grand_est_actuel_prenom},
      </p>

      <p>J'espère que votre prise de poste s'est bien passée.</p>
      <p>
        Je souhaitais vous faire un rapide rappel des points clés à préparer
        pour notre échange à venir.
      </p>
      <p>
        Afin de garantir son efficacité, merci de réfléchir aux éléments
        suivants et de m'envoyer par mail vos réponses:
      </p>

      <ul className="list-disc pl-12">
        <li>
          les <span>axes de développement pour l'entreprise </span>à court et
          moyen terme.
        </li>
        <li>
          les <span>actions, moyens et objectifs </span>
          que vous visez.
        </li>
        <li>
          le <span>mode de management </span>
          que vous comptez adopter, ainsi que <span>les valeurs </span>que vous
          souhaitez véhiculer.
        </li>
      </ul>
      <p>
        Je tiens à souligner que l'innovation est un point très important pour
        moi, et je suis ouverte à toutes propositions qui pourraient faire
        progresser notre entreprise.
      </p>

      <p>Bien cordialement,</p>
      <MailSignature
        emetteurLogo={PreparationPointVisio.metadata.emetteurLogo}
        emetteur={PreparationPointVisio.metadata.emetteur}
        emetteurPoste={PreparationPointVisio.metadata.emetteurPoste}
        emetteurEntreprise={PreparationPointVisio.metadata.emetteurEntreprise}
      />
    </div>
  );
}

PreparationPointVisio.metadata = {
  titre: "Préparation de notre point en visio.",
  cleMail: "preparation_point_visio",
  messageTransfert: false,
  emetteur: "Lucie Breton",
  emetteurPoste: "Présidente",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

// Visible uniquement quand tous les mails attendant une réponse ont été répondus
const displayCondition: DisplayCondition = ({
  reponses,
  templateMails,
  mailTypeReponses,
}) => {
  const otherMails = templateMails.filter(
    (m) => m.metadata.cleMail !== "preparation_point_visio",
  );
  const visibleOthers = otherMails.filter(
    (m) =>
      !m.displayCondition ||
      m.displayCondition({ reponses, templateMails, mailTypeReponses }),
  );
  const mailsAttendantReponse = visibleOthers.filter(
    (m) => mailTypeReponses[m.metadata.cleMail] !== "no_response",
  );
  const mailsSansReponse = visibleOthers.filter(
    (m) => mailTypeReponses[m.metadata.cleMail] === "no_response",
  );
  return (
    mailsAttendantReponse.length > 0 &&
    mailsAttendantReponse.every(
      (m) => reponses[m.metadata.cleMail]?.statut === StatutMailEnum.REPONDU,
    ) &&
    mailsSansReponse.every(
      (m) => reponses[m.metadata.cleMail]?.statut === StatutMailEnum.LU,
    )
  );
};

PreparationPointVisio.displayCondition = displayCondition;

export default PreparationPointVisio;
